<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="12" viewBox="0 0 22 12">
    <defs>
      <path
        id="kr1yfdfoga"
        d="M7.804 3.176c0 1.09 1.233 3.205 2.167 4.645V3.163c0-.556.453-1.006 1.014-1.006.56 0 1.014.45 1.014 1.006 0 .127-.022.247-.065.358l-1.67 4.744c.423.638.73 1.062.73 1.062s3.191-4.397 3.191-6.151C14.185 1.42 12.754 0 10.994 0c-1.762 0-3.19 1.421-3.19 3.176zm6.886 1.952l-3.238 5.778 5.465-3.478c.582-.372 1.22-.676 2.021-.676l1.826-.007-3.638-2.177c-.314-.187-.642-.27-.956-.27-.629 0-1.2.332-1.48.83zm-9.827-.56l-3.64 2.177 1.824.007c.805 0 1.443.304 2.024.676l5.466 3.478-3.24-5.778c-.277-.498-.849-.83-1.478-.83-.314 0-.643.082-.956.27zM16.375 9.02l-4.695 2.402h10.307l-1.169-1.441c-.648-.801-1.254-1.573-2.389-1.573-.543 0-1.207.177-2.054.612zm-15.204.96L0 11.424h10.31L5.614 9.021c-.848-.435-1.512-.612-2.055-.612-1.136 0-1.742.772-2.388 1.573z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g transform="translate(-605 -349) translate(128 190) translate(472 123) translate(5 36)">
              <use fill="#FFF" xlink:href="#kr1yfdfoga" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>